import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { MAIN_PHONE_FEATURE } from './main-phone-state';
import { reducerProvider, reducerToken } from './reducers';

function mainStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: { [MAIN_PHONE_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(MAIN_PHONE_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(mainStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class MainPhoneStoreModule {}
